<template>
  
      <div class="card left debug1" :style="{width, margin}">
            <div class="row ch left">
                  <h4 v-if="$slots.title" style="font-weight: 600;"><slot name="title"></slot></h4>
                  <div v-if="$slots.icon" class="pointer click" style="margin-left: 6px;margin-top: 2px;"><slot name="icon"></slot></div>                  
            </div>            
            <p v-if="$slots.desc" class="mini left" style="margin-bottom: 16px;"><slot name="desc"></slot></p>            
            <slot></slot>
      </div>
  
      
  <!-- <Card></Card> -->
</template>
<script>
import { defineComponent } from 'vue';
export default defineComponent({
      data() {return {}},
      props:{        
        width: {type:String, default: '250px'},
        margin: {type:String, default: '10px 20px 60px'},
      },      
});
</script>
<style scoped>
.card{
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: baseline;
      justify-content: left;
      margin-bottom: 72px;
      /* padding-bottom: 60px; */
}
</style>